<template>
  <div class="profile-sidebar kt-portlet kt-portlet--bordered">
    <uploader-card
      v-if="user.is_uploader"
      :user="user"
      :active-user="auth_user"
      :sidebar="true" />
    <user-card
      v-else
      :user="user"
      :auth-user="auth_user"
      :sidebar="true" />
  </div>
</template>

<script>
import UserCard from "VuePartials/UserCard";
import UploaderCard from "VuePartials/UploaderCard";

export default {
  name: "ProfileSidebar",
  components: {
    UserCard,
    UploaderCard,
  },
  data: () => ({
    user: window.user,
    auth_user: window.auth_user,
  }),
};

</script>

<style lang="scss" scoped>
    @use "~AssetsSass/_users.scss";

    h5 {
        font-size:1rem;
    }

    .card {
      border:none;
    }
</style>
